import { render, staticRenderFns } from "./TemplateTriggers.vue?vue&type=template&id=c8f77508&scoped=true"
import script from "./TemplateTriggers.vue?vue&type=script&lang=js"
export * from "./TemplateTriggers.vue?vue&type=script&lang=js"
import style0 from "./TemplateTriggers.vue?vue&type=style&index=0&id=c8f77508&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8f77508",
  null
  
)

export default component.exports